module.exports = {"350881001":"菁城街道","350881002":"桂林街道","350881100":"新桥镇","350881101":"双洋镇","350881102":"永福镇","350881103":"溪南镇","350881104":"和平镇","350881105":"拱桥镇","350881106":"象湖镇","350881107":"赤水镇","350881108":"西园镇","350881109":"南洋镇","350881110":"芦芝镇","350881203":"官田乡","350881204":"吾祠乡","350881205":"灵地乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350881.json
// module id = 1139
// module chunks = 0